import React from 'react';
import {
  Row, Col, Container, Button
} from 'react-bootstrap';
import ReactPlayer from 'react-player';
import { LinkContainer } from 'react-router-bootstrap';
import { Tron } from './Tron';

export const Home = () => {
  
  let homeTron = {
    title: 'Workspace ONE Excel Add-In (Beta)',
    description: 'This is the home page for the Workspace ONE Excel Add-In.',
    body: <><p> This Add-In allows you to access data from
      your Workspace ONE UEM API from within Excel</p>
      <p>Here you will find:
        <ul>
          <li>
            Links to installation documentation for the four platforms supported - Excel
            for iOS,
            MacOS, Windows and Office Online
          </li>
          <li>
            Documentation and videos on how to use the Add-In.
          </li>
          <li>
            Instructions on installing Caching API's for the Add-In
          </li>
        </ul></p>
      <h2>Quick 3 minute overview of version .1</h2>
      <ReactPlayer url="https://www.youtube.com/watch?v=FkMXh3vGbfg" config={{
        youtube: {
          playerVars: { showinfo: 1, controls: true }
        }
      }}>
      </ReactPlayer>
    </>
  };
  
  
  return (
    
    <Container>
      <Tron tronProps={homeTron}/>
      <Container>
        <Row>
          <Col md={4}>
            <h2>MacOs Install Guide</h2>
            <p>Installation document for MacOs</p>
            <LinkContainer to="/MacOs">
              <Button variant='secondary'>View details</Button>
            </LinkContainer>
          </Col>
          <Col md={4}>
            <h2>Windows Install Guide</h2>
            <p>Installation document for Windows</p>
            <LinkContainer to="/Windows">
              <Button variant='secondary'>View details</Button>
            </LinkContainer>
          </Col>
          <Col md={4}>
            <h2>iOS Install Guide</h2>
            <p>Installation document for iOS</p>
            <LinkContainer to="/ios">
              <Button variant='secondary'>View details</Button>
            </LinkContainer>
          </Col>
          <Col md={4} style={{ paddingTop: '40px' }}>
            <h2>Online Install Guide</h2>
            <p>Installation document for Excel Online</p>
            <LinkContainer to="/ExcelOnline">
              <Button variant='secondary'>View details</Button>
            </LinkContainer>
          </Col>
          <Col md={4} style={{ paddingTop: '40px' }}>
            <h2>Caching API Guide Windows</h2>
            <p>Installation document for the Windows Caching API</p>
            <LinkContainer to="/APIBackendWindows">
              <Button variant='secondary'>View details</Button>
            </LinkContainer>
          </Col>
          <Col md={4} style={{ paddingTop: '40px' }}>
            <h2>Caching API Guide MacOs</h2>
            <p>Installation document for the MacOs Caching API</p>
            <LinkContainer to="/APIBackendMacOs">
              <Button variant='secondary'>View details</Button>
            </LinkContainer>
          </Col>
        </Row>
      
      </Container>
    </Container>
  );
};

